export function ServicesScreen() {
	return (
		<div className="panel panel-services">
			<h2 className="services-heading">Сервисы</h2>
			<p className="services-intro muted">Выберите сервис ниже. Доступ зависит от прав вашей учётной записи.</p>
			<ul className="service-cards" role="list">
				<li className="service-card">
					<div className="service-card-header">
						<h3 className="service-card-title">Boardstats</h3>
						<a className="service-card-open" href="/boardstats/">
							Открыть
						</a>
					</div>
					<p className="service-card-desc">
						Статистика и отчёты по доскам: сводные показатели и активность в одном интерфейсе.
					</p>
				</li>
			</ul>
		</div>
	)
}
